import { EulaSectionContent } from '../../../../common/components/EulaSection/EulaSection'
import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { EulaType } from '../../../../modules/privateOffer/reducer'
import { FormikProps, useFormikContext } from 'formik'
import { useState } from 'react'
import { BoxV2, ExternalLink } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './ChannelOfferEula.styles'

export const ChannelOfferEula = ({
  receivedResaleAuthEulaUrl,
}: {
  receivedResaleAuthEulaUrl: string
}) => {
  const { classes } = useStyles()
  const [eulaErr, setEulaErr] = useState<string>('')
  const updateErr = (error: string) => {
    setEulaErr(error)
  }
  const formikProps = useFormikContext() as FormikProps<Record<string, unknown>>
  const { values, touched, errors } = formikProps

  return (
    <>
      <div data-testid="received-resale-auth-eula">
        <BoxV2
          heading={'End-user License Agreement (EULA)'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
        >
          <div className={classes.viewEulaContainer}>
            <p className={classes.viewEulaDescription}>
              ISV has provided an EULA for this reseller authorization. It will
              be presented to buyer alongside your EULA.{' '}
            </p>
            <ExternalLink href={receivedResaleAuthEulaUrl}>
              View EULA
            </ExternalLink>
          </div>
        </BoxV2>
      </div>
      <div data-testid="channel-offer-eula-uploader">
        <BoxV2
          heading={'Attach End-user License Agreement (EULA)'}
          headingIcon={
            <FontAwesomeIcon
              icon={faFileContract}
              style={{ width: '14px', height: '14px' }}
            />
          }
        >
          <EulaSectionContent
            defaultNow={defaultNow}
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            isMultiFileUpload={true}
            fileUploadDescription={
              'Upload up to 5 files one by one, use plain text .txt or PDF formats only. The maximum file size is 10 MB.'
            }
            fileUploadButtonText={'Upload files'}
            fileUploadContainerTitle={'Drag and drop files here'}
            quantity={5}
            eulaOptionsHeading={'Legal term documents'}
            isOptional={values?.eulaType !== EulaType.CUSTOM}
            showEulaFileUpload={true}
            showEulaOptions={false}
            fileSize={10}
            updateErr={updateErr}
            uploadError={eulaErr || (touched?.eulaFile ? errors?.eulaFile : '')}
            uploadFolderName="reseller_cppo_eula_files"
          />
        </BoxV2>
      </div>
    </>
  )
}
